import { RouteConfig } from 'vue-router';

import { permissionGrades } from '../Middleware/permission/Grades';

export const NAME_ROUTES_GRADES = {
  GRADES: 'notas'
};

export const Grades: Array<RouteConfig> = [
  {
    path: '/notas',
    component: () => import('@/layouts/Default/index.vue'),
    beforeEnter: permissionGrades,
    children: [
      {
        path: '',
        name: NAME_ROUTES_GRADES.GRADES,
        component: () => import(/* webpackChunkName: "notas" */ '@/pages/Grades/index.vue'),
        meta: { title: 'Notas' }
      }
    ]
  }
];
